import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';
import { useEffect, useState } from "react"
import Cookies from 'js-cookie';
// import handleLogout from '../../../utilities/handleFunctions/HandleLogout';
import { useTranslation } from 'react-i18next';
import { useLangUrl } from '../../../utilities/useLangUrl';
// import { useNavigate } from 'react-router-dom';

export default function HeaderAccount() {
    const [isLogIn, setIsLogIn] = useState(false);
    const { t } = useTranslation();
    // const navigate = useNavigate();
    const langUrl = useLangUrl();

    useEffect(() => {
        if (Cookies.get('token')) {
            setIsLogIn(true)
        }
    }, [isLogIn]);

    return (
        <>
            <FontAwesomeIcon type='button' icon={faUser} className={`user-account text-white ${isLogIn ? "bg-dark-beige" : "bg-light-orange"}  dropdown-toggle`} id="userDropdown" data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="false" />

            <ul className={`dropdown-menu dropdown-menu-end text-end ${isLogIn ? " bg-med-gray" : "bg-light-orange"} border-white`} aria-labelledby="userDropdown">
                {isLogIn ?
                    <>
                        <li>
                            <Link className="dropdown-item" to={`${langUrl}/myAccount`}>
                                {/* <FontAwesomeIcon className='me-3' icon={faGrip} /> */}
                                {t("My Account")}</Link>
                        </li>
                        <li>
                            <Link className="dropdown-item"
                                onClick={() => {
                                    Cookies.remove("token");
                                    setIsLogIn(false);
                                    window.location.href = `${langUrl}/logIn`;
                                }
                                }
                                to="/">
                                {/* <FontAwesomeIcon className='me-3' icon={faArrowRightFromBracket} /> */}
                                {t("logout")}
                            </Link>
                        </li>
                    </>
                    :
                    <>
                        <li>
                            <Link className="dropdown-item" to={`${langUrl}/logIn`}>{t("login")}</Link>
                        </li>
                        <li>
                            <Link className="dropdown-item" to={`${langUrl}/register`}>{t("register")}</Link>
                        </li>
                    </>
                }
            </ul>
        </>

    )
};



